import { FETCH_RATE_PLANS_FAILURE, FETCH_RATE_PLANS_REQUEST, FETCH_RATE_PLANS_SUCCESS } from '../actions/ratePlans';

interface RatePlanState {
  loading: boolean;
  ratePlans: Array<any>;
  total: number;
  vendorNames: Record<string, string>;
  error: string | null;
}

const initialState: RatePlanState = {
  loading: false,
  ratePlans: [],
  total: 0,
  vendorNames: {},
  error: null,
};

export default function ratePlansReducer(state = initialState, action): RatePlanState {
  switch (action.type) {
    case FETCH_RATE_PLANS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_RATE_PLANS_SUCCESS:
      return {
        ...state,
        loading: false,
        ratePlans: action.payload.ratePlans,
        total: action.payload.total,
        vendorNames: action.payload.vendorNames,
      };
    case FETCH_RATE_PLANS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
